import React from 'react'
import SiteUrlManageForm from './SiteUrlManageForm'
import SetTitle from '../../utils/set_title'
import Header from '../../components/Headers/Header'

export default function SiteUrlManage() {
  SetTitle('SEO Site Manager')
  const description = (
    <>
      Il <b>Domain URL</b> può essere nella forma https://example.com o sc-domain:example.com
      <br />
      Il <b>secret name</b> è necessario per la raccolta di nuovi url ogni mese, e deve essere una credenziale utile a connettersi a questo specifico dominio su Google Search Console.
    </>
  )

  return (
    <Header
      iconClass="ni ni-compass-04 text-white"
      title="SEO Site Manager"
      description={description}
    >
      <SiteUrlManageForm />
    </Header>
  )
}